import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { costBearerColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';

import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { CostBearersRepository } from '@Repositories/Stammdaten';

export function FrameListCostBearer() {
    const hasPermission = useHasPermission();

    const module = useListApi(CostBearersRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings
            layoutSettingsContext={EnumFrontendLayoutSetting.CostBearersTableLayout}
            name={'CostBearerList'}
            columns={costBearerColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenCostBearerCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
